import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_REMINDERS = `${BASE_URL}/api/reminders`;

export class RemindersApi {
  static async getReminders() {
    return (await axiosInstance.get(`${BASE_URL_REMINDERS}`)).data;
  }

  static async addReminder(reminder) {
    return (await axiosInstance.post(`${BASE_URL_REMINDERS}`, reminder)).data;
  }

  static async updateReminder(reminderId, updatedFields) {
    return (
      await axiosInstance.patch(
        `${BASE_URL_REMINDERS}/${reminderId}`,
        updatedFields,
      )
    ).data;
  }

  static async deleteReminder(reminderId) {
    return await axiosInstance.delete(`${BASE_URL_REMINDERS}/${reminderId}`);
  }
}
